import { useState, useEffect } from "react";
import { Users, Minus, Plus } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface PeopleCountDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  destinationType: "table" | "tab";
  destinationNumber: string;
  onConfirm: (peopleCount: number) => void;
}

export function PeopleCountDialog({
  open,
  onOpenChange,
  destinationType,
  destinationNumber,
  onConfirm,
}: PeopleCountDialogProps) {
  const [peopleCount, setPeopleCount] = useState(1);

  // Reset when dialog opens
  useEffect(() => {
    if (open) {
      setPeopleCount(1);
    }
  }, [open]);

  const handleConfirm = () => {
    onConfirm(peopleCount);
    onOpenChange(false);
  };

  const increment = () => setPeopleCount((prev) => prev + 1);
  const decrement = () => setPeopleCount((prev) => Math.max(1, prev - 1));

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Users className="h-5 w-5 text-primary" />
            Quantas pessoas na {destinationType === "table" ? "mesa" : "comanda"} {destinationNumber}?
          </DialogTitle>
        </DialogHeader>

        <div className="py-6">
          <Label className="text-center block mb-4 text-muted-foreground">
            Informe o número de pessoas para cálculo do ticket médio
          </Label>
          <div className="flex items-center justify-center gap-4">
            <Button
              variant="outline"
              size="icon"
              className="h-14 w-14 rounded-full"
              onClick={decrement}
              disabled={peopleCount <= 1}
            >
              <Minus className="h-6 w-6" />
            </Button>
            <Input
              type="number"
              min="1"
              value={peopleCount}
              onChange={(e) => setPeopleCount(Math.max(1, parseInt(e.target.value) || 1))}
              className="w-24 h-14 text-3xl font-bold text-center"
            />
            <Button
              variant="outline"
              size="icon"
              className="h-14 w-14 rounded-full"
              onClick={increment}
            >
              <Plus className="h-6 w-6" />
            </Button>
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button onClick={handleConfirm}>
            Confirmar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
